import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { utcToLocal } from "../../utils/dateConvert";

class NotificationTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      UserList: [],
      sortString: "customer",
      sortDirection: "asc",
    };
    this.sortStringName = "customer";
    this.sortDirection = "asc";
  }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };

  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };
  componentDidMount() { }

  renderSortHeader = (label, sortKey) => {
    const active = this.state.sortString === sortKey;
    const iconClass = active && this.state.sortDirection === "des"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`notification-sort-button ${active ? "active" : ""}`}
        onClick={() => active ? this.handleSortDirection() : this.handleSortString(sortKey)}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  renderStatus = (status) => {
    const active = status === 1 || (status || "").toString().toLowerCase() === "active";

    return (
      <span className={`notification-status-pill ${active ? "active" : "disabled"}`}>
        {active ? "Active" : "Disabled"}
      </span>
    );
  };

  renderConfiguration = (config) => {
    try {
      return this.handleConfiguration(config);
    } catch (e) {
      return "-";
    }
  };

  tConvert = (time) => {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  };

  handleConfiguration = (config) => {
    console.log("data parsed", JSON.parse(config));
    let data = JSON.parse(config);
    let days = data.Days;
    console.log("days", days);
    // days={"Friday": true, "Saturday": true, "Thursday": true, "Wednesday": true}
    let dayList = this.extractDays(days);
    console.log("true day list", dayList);
    let Hours = data.Hours;
    let startTimeHour = moment.utc(data.Period.Start).get("hour");
    let startTimeMinutes = moment.utc(data.Period.Start).get("minute");
    if (startTimeHour < 10) {
      startTimeHour = "0" + startTimeHour;
    }
    if (startTimeMinutes < 10) {
      startTimeMinutes = "0" + startTimeMinutes;
    }
    let Start = this.tConvert(`${startTimeHour}:${startTimeMinutes}`);
    let endTimeHour = moment.utc(data.Period.End).get("hour");
    let endTimeMinutes = moment.utc(data.Period.End).get("minute");
    if (endTimeHour < 10) {
      endTimeHour = "0" + endTimeHour;
    }
    if (endTimeMinutes < 10) {
      endTimeMinutes = "0" + endTimeMinutes;
    }
    let End = this.tConvert(`${endTimeHour}:${endTimeMinutes}`);
    console.log("time", Start, End);
    // console.log("hours", Hours,Start,End);
    let activeHours = this.handleActiveHour(Hours, Start, End);
    // let activeHours="1";
    let Email = this.handleEmail(data.Email);
    return dayList + " " + activeHours + " " + Email;
  };
  handleEmail = (email) => {
    let emailDescription;
    if (email) {
      emailDescription = "Email sent";
    } else {
      emailDescription = "Email disabled";
    }
    return emailDescription;
  };

  handleActiveHour = (hours, start, end) => {
    let activeDescription;
    if (hours == 1) {
      activeDescription = "All day (24 hours) ";
    } else if (hours == 2) {
      activeDescription = "Events occuring within " + start + " and " + end;
    } else if ((hours = 3)) {
      activeDescription = "Events occuring outside " + start + " and " + end;
    }
    return activeDescription;
  };

  extractDays = (days) => {
    let DayArr = [];
    let j = 0;
    for (let i in days) {
      if (days[i]) {
        DayArr[j] = i.slice(0, 3);
        j++;
      }
    }

    for (let i in DayArr) {
      if (DayArr[i] == "Mon") {
        DayArr[i] = DayArr[0];
        DayArr[0] = "Mon";
      } else if (DayArr[i] == "Tue") {
        DayArr[i] = DayArr[1];
        DayArr[1] = "Tue";
      } else if (DayArr[i] == "Wed") {
        DayArr[i] = DayArr[2];
        DayArr[2] = "Wed";
      } else if (DayArr[i] == "Thu") {
        DayArr[i] = DayArr[3];
        DayArr[3] = "Thu";
      } else if (DayArr[i] == "Fri") {
        DayArr[i] = DayArr[4];
        DayArr[4] = "Fri";
      } else if (DayArr[i] == "Sat") {
        DayArr[i] = DayArr[5];
        DayArr[5] = "Sat";
      } else if (DayArr[i] == "Sun") {
        DayArr[i] = DayArr[6];
        DayArr[6] = "Sun";
      }
    }

    for (let i = 0; i < DayArr.length; i++) {
      if (typeof DayArr[i] != "undefined") {
        DayArr[i] = " " + DayArr[i];
      }
    }

    var filteredArr = DayArr.filter((el) => {
      return el != null;
    });

    return filteredArr;
  };

  render() {
    const isPersonalMode = this.props.isPersonalMode;
    const emptyColSpan = isPersonalMode ? 7 : 9;

    return (
      <div className="notification-table-wrap">
        <Table className="notification-modern-table" responsive>
          <thead>
            <tr>
              {!isPersonalMode && <th>{this.renderSortHeader("Customer", "customer")}</th>}
              {!isPersonalMode && <th>{this.renderSortHeader("User", "user")}</th>}
              <th>{this.renderSortHeader("Name", "name")}</th>
              <th>Notification #</th>
              <th>Description</th>
              <th>{this.renderSortHeader("Status", "status")}</th>
              <th>Configuration</th>
              <th>{this.renderSortHeader("Updated", "updated")}</th>

              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.props.NotificationList.length === 0 && (
              <tr>
                <td className="notification-empty" colSpan={emptyColSpan}>
                  No notifications match your search.
                </td>
              </tr>
            )}
            {this.props.NotificationList.map((Notification, index) => {
              return (
                <tr key={Notification.id || index}>
                  {!isPersonalMode && (
                    <td>
                      <a
                        className="notification-customer-link"
                        onClick={() =>
                          localStorage.setItem(
                            "customer",
                            JSON.stringify({
                              customerId: Notification.customerId,
                              customerName: Notification.customerName,
                            })
                          )
                        }
                        href={`/notifications?customerId=${Notification.customerId}&customerName=${Notification.customerName}`}
                      >
                        {Notification.customerName || "-"}
                      </a>
                    </td>
                  )}
                  {!isPersonalMode && <td>{Notification.userName || "-"}</td>}
                  <td>
                    <strong>{Notification.name || "-"}</strong>
                  </td>
                  <td>{Notification.uniqueId || "-"}</td>

                  <td className="notification-description">{Notification.description || "-"}</td>

                  <td>{this.renderStatus(Notification.status)}</td>
                  <td className="notification-config">{this.renderConfiguration(Notification.config)}</td>

                  <td>
                    {Notification.dbUpdated
                      ? utcToLocal(Notification.dbUpdated)
                      : ""}
                  </td>
                  <td className="notification-actions">
                    <Link to={`/editNotification/${Notification.id}`}>
                      Edit
                    </Link>
                    <Link to={`/notificationDetails/${Notification.id}`}>
                      Details
                    </Link>
                    <Link to={`/notificationDelete/${Notification.id}`}>
                      Delete
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default NotificationTable;
